<script setup>
import SidebarEntries from './SidebarEntries.vue';

const props = defineProps(['entries', 'level']);
</script>

<template>
    <ul class="list-unstyled" :style="`padding-left: ${level * 20}px;`">
        <li v-for="entry in entries">
            <template v-if="entry.route">
                <router-link :to="{ name: entry.route }">{{ entry.title }}</router-link>
            </template>
            <template v-else>
                <span class="section-title">{{ entry.title }}</span>
            </template>
            <template v-if="entry.children && entry.children.length">
                <SidebarEntries :entries="entry.children" :level="level + 1"></SidebarEntries>
            </template>
        </li>
    </ul>
</template>
